const rankings = [
  { title: '某顶流男星深夜密会神秘女子，酒店监控画面曝光', heat: '238w', trend: 'up' },
  { title: '网红主播直播间口误，意外曝光千万签约内幕', heat: '186w', trend: 'up' },
  { title: '知名导演新片选角风波，多位一线明星卷入争议', heat: '152w', trend: 'up' },
  { title: '娱乐圈模范夫妻被曝已分居，双方工作室紧急回应', heat: '129w', trend: 'hot' },
  { title: '选秀节目导师内部冲突升级，节目组紧急调整赛制', heat: '98w', trend: 'up' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-12">
          <span className="inline-block text-xs font-label tracking-wider text-accent-600 bg-accent-100 px-4 py-1.5 rounded-full mb-4 whitespace-nowrap">
            实时热度
          </span>
          <h2 className="font-heading text-[32px] md:text-[40px] text-foreground-950">今日热瓜榜</h2>
          <p className="text-sm text-foreground-500 mt-3">全网热搜话题实时排名，热度最高的瓜都在这里</p>
        </div>

        <div className="flex flex-col gap-3 max-w-[800px]">
          {rankings.map((item, i) => (
            <div
              key={i}
              className="group flex items-center gap-4 md:gap-6 bg-background-50 rounded-2xl p-4 md:p-5 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <span className={`font-heading text-[32px] md:text-[40px] leading-none w-12 md:w-14 text-center flex-shrink-0 ${
                i < 3 ? 'text-primary-500' : 'text-foreground-300'
              }`}>
                {i + 1}
              </span>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-[15px] md:text-base text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {item.title}
                </h3>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span className={`text-xs font-medium px-3 py-1 rounded-full whitespace-nowrap ${
                  item.trend === 'hot' ? 'bg-primary-100 text-primary-700' : 'bg-accent-100 text-accent-700'
                }`}>
                  <i className={`${item.trend === 'hot' ? 'ri-fire-line' : 'ri-arrow-up-line'} mr-1`}></i>
                  {item.heat}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}